<template>
  <div
    class="reservation-card"
    :style="imageUrl ? { backgroundImage: 'url(' + imageUrl + ')' } : {}"
  >
    <div class="bg-overlay"></div>
    <div class="content-on-image">
      <h2 class="text-center">{{ title }}</h2>
      <button @click="reservationInfo = !reservationInfo" class="button font-clanpro-bold">{{ callToAction }}</button>
    </div>
    <transition name="fade">
      <div v-if="reservationInfo" class="expanded-content">
        <div class="expanded-header">
          <h2 class="expanded-title">{{ title }}</h2>
          <button class="close-btn" @click="reservationInfo = false">&times;</button>
        </div>
        <div class="row p-3 m-0 row-style">
          <div class="col-12 mb-3">
            <slot name="parent-rectangle">
              <div class="content-style">
                <p class="font-clanpro" v-html="textRetangle"></p>
              </div>
            </slot>
          </div>
          <div class="col-12 mb-3">
            <slot name="formContent"></slot>
          </div>
          <div class="col-12">
            <slot name="slotContent"></slot>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reservationInfo: false
    }
  },
  props: {
    showModal: { type: Boolean, required: false },
    title: { type: String, required: false },
    titleRetangle: { type: String, required: false },
    textRetangle: { type: String, required: false },
    imageUrl: { type: String, required: false },
    flexDirection: { type: String, required: false },
    callToAction: { type: String, required: false }
  }
};
</script>

<style scoped>
.reservation-card {
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;
  min-height: 320px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.12), 0 1.5px 6px rgba(0,0,0,0.10);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.45);
  z-index: 1;
}
.content-on-image {
  position: relative;
  z-index: 2;
  color: #fff;
  text-align: center;
  width: 100%;
  padding: 2rem 1rem 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.content-on-image h2 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-shadow: 0 2px 8px rgba(0,0,0,0.4);
}
.button {
  background: rgba(255,255,255,0.15) !important;
  color: #fff;
  border: 1.5px solid #fff;
  border-radius: 8px;
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  margin-top: 0.5rem;
  transition: background 0.2s, color 0.2s;
}
.button:hover {
  background: #fff !important;
  color: #222;
}
.expanded-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  color: #222;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18), 0 2px 8px rgba(0,0,0,0.12);
  z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  overflow-y: auto;
  max-height: 80vh;
}
.expanded-header {
  position: sticky;
  top: 0;
  background: #f8f8f8;
  z-index: 20;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1rem;
}
.expanded-title {
  font-weight: 600;
  color: #222;
  margin: 0;
  flex: 1;
  text-align: left;
  font-size: 1.2rem;
}
.close-btn {
  background: none;
  border: none;
  font-size: 2.2rem;
  color: #888;
  cursor: pointer;
  z-index: 20;
  transition: color 0.2s, background 0.2s;
  margin-left: 1.5rem;
  margin-right: 0.2rem;
  line-height: 1;
  padding: 0.2rem 0.5rem;
  border-radius: 50%;
}
.close-btn:hover {
  color: #222;
  background: #ececec;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
@media (max-width: 768px) {
  .reservation-card {
    aspect-ratio: 1/1;
    min-height: 220px;
  }
  .content-on-image h2 {
    font-size: 1.2rem;
  }
  .expanded-content {
    max-height: 90vh;
  }
  .expanded-content .col-lg-8 > .form-content-wrapper {
    padding: 1rem 0.2rem;
    max-width: 100%;
  }
  .button {
    font-size: 0.8rem;
  }
}
.slot-empty:empty{
    display: none;
}
.row-style{
    background-color: #ddb427;
    flex-wrap: wrap;
    border: 1px solid #000;
}
.expanded-content .col-lg-8 > .form-content-wrapper {
  padding: 2rem 1.5rem;
  max-width: 600px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}
.square-style{
    background-color: #DDB427;
    border: 1px solid black;
    border-radius: 14px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.07);
    width: 220px;
    min-width: 180px;
    max-width: 240px;
    margin: 0 auto;
    padding: 1.2rem 0.7rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: fit-content;
}
@media (max-width: 900px) {
  .square-style {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
  }
}
.expanded-content .col-lg-8 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.expanded-content .form-content-wrapper {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  padding: 2rem 2.5rem;
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
}
@media (max-width: 900px) {
  .expanded-content .form-content-wrapper {
    padding: 1.2rem 0.5rem;
    max-width: 100%;
  }
}
.form-content-wrapper .form-control {
  margin-bottom: 1.1rem;
  font-size: 1.08rem;
}
.form-content-wrapper label {
  font-size: 1.08rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
}
.form-content-wrapper .invalid-feedback {
  color: #b94a48;
  font-size: 0.93rem;
  margin-top: -0.7rem;
  margin-bottom: 0.7rem;
}
.form-content-wrapper .is-invalid {
  border-color: #b94a48;
  background: #fff6f6;
}
.form-content-wrapper .button {
  margin-top: 0.7rem;
  width: 100%;
}
.container, .container-fluid, .container-xxl, .container-xl, .container-lg, .container-md, .container-sm{
  padding-left: 30px !important;
  padding-right: 30px !important;
}
.div-style{
  background-color: #cfcbcb;
  height: 439px;
  position: relative;
  overflow: hidden;
}
.content-align{
  display: grid;
  justify-content: center;
  align-content: center;
}
.image-style{
  object-fit: cover;
  width: 100%;
  height: 439px;
}
.row-spaces{
  margin: 20px 0;
  flex-wrap: wrap;
  flex-direction: column;
}
#small-ecample-responsivity{
  display: flex;
}
@media (max-width: 400px) {
  #small-ecample-responsivity{
    display: grid !important;
  }
}
.content-style {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>